import { IBaseResponse, IPagination, IPaginationQueryParams } from "./shared"

interface ICarBaseType {
  id: number
  name: string
  imageUrl?: string
}

export interface ICarWashType extends ICarBaseType {
  isActive: boolean
  price?: number
  washTime?: number
}

export interface ICarBodyType extends ICarBaseType {
  washTypes: ICarWashType[]
}

export interface IAdditionalService extends ICarBaseType {
  isActive: boolean
}

export interface ILaundry {
  id: number
  name: string
  address: string
  district: string
  phoneNumber?: number
  idNumber?: string
  bankAccount?: string
  email?: string
  logoUrl?: string
  locationLatitude?: number
  locationLongitude: number
  boxCount: number
  workStartTime: string
  workEndTime: string
  is24Houres: boolean
}

export interface ILaundryDetailed extends ILaundry {
  bodyTypes: ICarBodyType[]
  additionalServices: IAdditionalService[]
}

export interface ILaundryShort extends ILaundry {
  changeRequestCount: number
  isNew: boolean
  isOpen: boolean
}

export interface IGetLaundryRes extends IBaseResponse {
  data: ILaundryDetailed
}

export interface IGetLaundriesRes extends IPagination {
  data: ILaundryShort[]
}

export interface IGetLaundryHolidaysQueryParams extends IPaginationQueryParams {
  laundryId: number
}

export interface IGetAdminLaundryHolidaysQueryParams
  extends IPaginationQueryParams {
  carWashIds: Array<number>
}

// GET Laundry holidays
export interface ILaundryHoliday {
  id: number
  carWashId: number
  fromDateTime: string
  toDateTime: string
}

export interface IAdminLaundryHoliday {
  id: number
  carWashId: number
  carWashName: string
  carWashAddress: string
  carWashLogoUrl: string
  fromDateTime: string
  toDateTime: string
}

export interface IGetLaundryHolidaysData extends IPagination {
  data: ILaundryHoliday[]
}

export interface IGetAdminLaundryHolidaysData extends IPagination {
  data: IAdminLaundryHoliday[]
}
export interface IGetLaundriesData extends IPagination {
  data: ILaundryShort[]
}
export interface IGetLaundryHolidaysRes extends IBaseResponse {
  data: IGetLaundryHolidaysData
}

export interface IAddLaundryHolidayBody {
  carWashId: number
  fromDateTime: Date
  toDateTime: Date
}

export interface IAddAdminLaundryHolidayBody {
  carWashIds: Array<number>
  fromDateTime: Date
  toDateTime: Date
}

export interface IEditLaundryHolidayBody {
  carWashId: number
  fromDateTime: Date
  toDateTime: Date
  id: number
}

export enum ILaundryStatus {
  PENDING = "PENDING",
  OPEN = "OPEN",
  NEW = "NEW",
}

export interface IChangeItem {
  field: string
  type: number
  newValue?: string
  oldValue?: string
}

export enum NORMALIZED_CHANGE_ITEM_TYPE {
  TEXT = "TEXT",
  IMG = "IMG",
  LOCATION = "LOCATION",
  WASH_TYPE = "WASH_TYPE",
  ADDITIONAL_SERVICE = "ADDITIONAL_SERVICE",
}

export interface INormalizedChangeItem {
  field: string
  type: NORMALIZED_CHANGE_ITEM_TYPE
  typeId: number
  value?: string
}

export interface IGetLaundryChangesHistoryRes extends IBaseResponse {
  data: IChangeItem[]
}

export interface IApproveRejectLaundryUpdatesBody {
  carWashId: number
  status: number
  comment?: string
}

// Get Laundry Branches for Dropdown
export interface ILaundryBranch {
  id: number
  logoUrl: string
  name: string
  address: string
  scheduleInterval?: number
  commissionType?: number
  commissionTypeString?: string
  commission?: number
}
export interface IGetLaundryBranchesData extends IPagination {
  data: ILaundryBranch[]
}
export interface IGetLaundryBranchesRes extends IBaseResponse {
  data: IGetLaundryBranchesData
}

export interface ILaundryBranchOption {
  id: number
  value: string
  label: string
  img: string
}

export interface ILaundryDistrict {
  id: number
  name: string
}

export interface IGetLaundryDistrictsRes extends IBaseResponse {
  data: ILaundryDistrict[]
}

export interface IGetLaundriesQueryParams extends IPaginationQueryParams {
  isOpen?: boolean | null
  search?: string
  sortOrder?: number
}

export interface IGetLaundryBranchesQueryParams extends IPaginationQueryParams {
  search: string
  sortOrder: number
}

export interface IGetLaundryScheduleIntervalRes extends IBaseResponse {
  data: string
}

export interface ILaundryCommission {
  commission: number | ""
  commissionType: number
}

export interface IGetLaundryCommissionRes extends IBaseResponse {
  data: ILaundryCommission
}
export interface IChangeLaundryScheduleIntervalBody {
  carWashIds: number[]
  scheduleInterval: number
}

export interface IChangeLaundryCommissionBody {
  carWashIds: number[]
  commissionType: number
  commission: number
}

export interface ICancelCommissionData {
  sortId: number
  commissionType: number
  commissionTypeString: string
  commission: number
  cancelBeforeMinute: number
}
export interface IChangeLaundryCancelCommissionsBody {
  carWashIds: number[]
  commissionData: ICancelCommissionData[]
}

export interface ILaundryCancelCommission {
  sortId: number
  commissionType: number
  commissionTypeString: string
  commission: number | ""
  cancelBeforeMinute: number | ""
}

export interface IGetLaundryCancelCommissionData {
  carWashId: number
  carWashName: string
  carWashAddress: string
  carWashLogoUrl: string
  commissionData: ICancelCommissionData[]
}
export interface IGetLaundryCancelCommissionsRes extends IBaseResponse {
  data: IGetLaundryCancelCommissionData[]
}

export interface IGetLaundryWithChangesCountRes extends IBaseResponse {
  data: number
}

export interface IVerifiedBoxAssignInfo {
  data: number[]
  status: number
  statusDescription: string
}
